module.exports = "/_next/static/images/cx-a434363645c22e5ce1e5b2bde8dd0282.svg";